export default __webpack_public_path__ + "static/media/pyk_logo.2e2e20e7.svg";